// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"TruncateText_textContainer__5nshi","truncate":"TruncateText_truncate__137fR","expanded":"TruncateText_expanded__EAGwS","more":"TruncateText_more__5xNDj"};